import type { ReactElement } from 'react';

import { TaskFormWizard } from '@/components/tasks/wizard/TaskFormWizard/TaskFormWizard';
import { useGeoMarkupStore } from '@/store';

/**
 * Thin wrapper around `TaskFormWizard` that re-applies the remount key
 * whenever `formMode` toggles between `create ↔ edit ↔ null`. The key
 * forces the wizard's internal state to reset, so editing an existing
 * task never inherits transient state from a previous `new` draft.
 *
 * Encapsulating the key-hack here keeps `MapView` generic — it only
 * iterates the artifact registry without knowing about task-specific
 * form mode semantics.
 *
 * Lives in `src/artifacts/` next to `tasks.ts` because the wrapper is
 * an implementation detail of the tasks artifact registration. It is
 * deliberately in its own file so `tasks.ts` (which exports only data)
 * does not trip the `react-refresh/only-export-components` rule.
 */
export function TaskFormPanel(): ReactElement {
  const taskFormMode = useGeoMarkupStore((state) => state.tasks.formMode);
  return <TaskFormWizard key={`task-form-${taskFormMode ?? 'closed'}`} />;
}
